import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add Authorization header from localStorage as a fallback (some browsers block
// cross-site cookies). The backend accepts either cookie or Bearer token.
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("gs_token") : null;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const ASSETS = {
  // New black-background logo replaces the white-bg variant.
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/tu9k7uaa_ChatGPT%20Image%20Jul%2014%2C%202026%20at%2003_35_56%20PM.png",
  lambo: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/dt7xdf18_Lamborghini%20Branding%20Banner.png",
  helipad: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/pg5kxzew_ChatGPT%20Image%20Jul%2017%2C%202026%20at%2009_07_09%20PM.png",
  billboard: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/ntdu6gky_BASQO%20Billboard%20Branding%20Hero%20Logo%20Banner.png",
  pool: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/n6tlbrha_Grail%20Swaq%20Pool%20Overhead%20with%20Logo.png",
  basqo: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/wbawvxa9_BASQO%20White%20Graphic%20Tee.png",
  basqet: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/z7qzllcm_BASQET%20Black%20Tee.png",
  fiftytwo: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/ns4h9rr6_FIFTY%20TWO%20White%20Hoody.png",
  // Drop-print artworks (used in the mobile header). Light edges are masked out via CSS so they blend into the black header.
  printBasqo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/m78d6t2f_Grail%20Swag%20BOSQO%20Limited%20Drop%20Logo.png",
  printBasqet: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/ggdookz1_BASQET%20Grail%20Swag%20MJ%20Art.png",
  printFiftytwo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/703d2p8y_ChatGPT%20Image%20Jul%2017%2C%202026%20at%2008_22_37%20PM.png",
};

// Drop metadata is entirely static (only 3 drops, they never change),
// so we ship it with the frontend bundle. The site renders the Drops
// section and all drop pages even if the backend is unavailable or the
// production DB hasn't been seeded yet.
export const DROPS = [
  {
    id: "BASQO",
    name: "BASQO",
    tagline: "Regal graffiti kingdom on the tarmac — private-jet luxury meets crowned street art.",
    story: "Chapter 01. A crowned wordmark drenched in blue-chip primary colors, worn like a signature on a canvas. Tarmac ready, gallery approved.",
    hero_image: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/wbawvxa9_BASQO%20White%20Graphic%20Tee.png",
  },
  {
    id: "BASQET",
    name: "BASQET",
    tagline: "Slam-dunk grail. Court-side energy, hardwood mythology.",
    story: "Chapter 02. Playground poetry, hardwood mythology. A stroke-painted tribute to the moment air becomes legend.",
    hero_image: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/z7qzllcm_BASQET%20Black%20Tee.png",
  },
  {
    id: "FIFTYTWO",
    name: "FIFTYTWO",
    tagline: "Inspired by iconic baseball card collector culture.",
    story: "Chapter 03. A love letter to the rookies, the rare, and the reverent — inspired by the iconic culture of baseball card collecting where a piece of cardboard becomes a lifelong grail.",
    hero_image: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/ns4h9rr6_FIFTY%20TWO%20White%20Hoody.png",
  },
];
export const DROPS_BY_ID = Object.fromEntries(DROPS.map((d) => [d.id, d]));

// Static product catalog — ships with the bundle so /shop, /drops/*, /product/*
// all render even if the API is unavailable or the production DB is empty.
// The API-returned products (with live sold_count) override these when available.
const _p = (id, drop, type, name, price, sizes, images) => ({
  id, drop, type, name, price,
  description: `${DROPS_BY_ID[drop].tagline} A GrailSwag ${name.toLowerCase()} from the ${drop} drop. Museum-quality print, heavyweight premium cotton, limited to 500 units across all sizes and colors.`,
  sizes,
  colors: ["black", "white"],
  unit_limit: 500,
  sold_count: 0,
  image_url: images.black || images.white || Object.values(images)[0],
  images,
  active: true,
});
const APPAREL_SIZES = ["S", "M", "L", "XL", "XXL"];
const HAT_SIZE = ["OS"];
export const PRODUCTS = [
  _p("basqo-tee", "BASQO", "tee", "BASQO Premium Tee", 95, APPAREL_SIZES, {
    white: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/wbawvxa9_BASQO%20White%20Graphic%20Tee.png",
    black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/f2lok9h1_BASQO%20Black%20Graphic%20Tee.png",
  }),
  _p("basqo-hoodie", "BASQO", "hoodie", "BASQO Premium Pullover Hoodie", 175, APPAREL_SIZES, {
    white: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/n5e6g2pt_BASQO%20White%20Graphic%20Hoodie.png",
    black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/fjbcc5eg_BASQO%20Black%20Graphic%20Hoodie.png",
  }),
  _p("basqo-hat", "BASQO", "hat", "BASQO Embroidered Hat", 55, HAT_SIZE, {
    white: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/vp9vxv56_BASQO%20White%20Graphic%20Hat%201.png",
    black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/nqjedzia_BASQO%20Black%20Graphic%20Hat.png",
  }),
  _p("basqet-tee", "BASQET", "tee", "BASQET Premium Tee", 95, APPAREL_SIZES, {
    white: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/pit9lfnu_BASQET%20White%20Tee.png",
    black: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/z7qzllcm_BASQET%20Black%20Tee.png",
  }),
  _p("basqet-hoodie", "BASQET", "hoodie", "BASQET Premium Pullover Hoodie", 175, APPAREL_SIZES, {
    white: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/u5m5qx6b_BASQET%20White%20Hoodie.png",
    black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/oarhscsi_BASQET%20Black%20Hoody.png",
  }),
  _p("basqet-hat", "BASQET", "hat", "BASQET Embroidered Hat", 55, HAT_SIZE, {
    white: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/sog249sm_BASQET%20Hat%20White.png",
    black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/rjisa8dg_BASQET%20HAT%20Black.png",
  }),
  _p("fiftytwo-tee", "FIFTYTWO", "tee", "FIFTYTWO Premium Tee", 95, APPAREL_SIZES, {
    white: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/8qgvj7am_FIFTYTWO%20WHITE%20TEE.png",
    black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/nqsohmou_FIFTYTWO%20BLACK%20TEE.png",
  }),
  _p("fiftytwo-hoodie", "FIFTYTWO", "hoodie", "FIFTYTWO Premium Pullover Hoodie", 175, APPAREL_SIZES, {
    white: "https://customer-assets-v7afamib.emergentagent.net/job_407142c4-9931-4fdc-95ec-8b1125f9fe19/artifacts/ns4h9rr6_FIFTY%20TWO%20White%20Hoody.png",
    black: "https://customer-assets-m6fa6gv7.emergentagent.net/job_collector-apparel/artifacts/iq6w7sgb_FIFTY%20TWO%20BLACK%20HOODIE.png",
  }),
];
// FIFTYTWO leads with the black tee (matches admin request from earlier).
PRODUCTS.find((p) => p.id === "fiftytwo-tee").image_url = PRODUCTS.find((p) => p.id === "fiftytwo-tee").images.black;
// BASQET hoodie leads with white.
PRODUCTS.find((p) => p.id === "basqet-hoodie").image_url = PRODUCTS.find((p) => p.id === "basqet-hoodie").images.white;
export const PRODUCTS_BY_ID = Object.fromEntries(PRODUCTS.map((p) => [p.id, p]));
export const productsForDrop = (dropId) => PRODUCTS.filter((p) => p.drop === dropId.toUpperCase());

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmt = (n) => `$${Number(n).toFixed(2)}`;

/**
 * Route any CDN image through the backend resize/re-encode proxy so a 2-3MB PNG
 * becomes a ~50-150KB WebP sized to the exact display width. Returns the
 * original URL unchanged if `src` is falsy or already a data/proxy URL.
 */
export function img(src, width = 800, quality = 78) {
  if (!src || typeof src !== "string") return src;
  if (src.startsWith("data:") || src.includes("/api/img")) return src;
  const u = encodeURIComponent(src);
  return `${API}/img?u=${u}&w=${width}&q=${quality}&fmt=webp`;
}
